// extracted by mini-css-extract-plugin
export default {"datosClienteWrapper":"CustomerData_datosClienteWrapper__O7Fh0","buttonSend":"CustomerData_buttonSend__UHJUW","error":"CustomerData_error__dBRlU"};